import { useRenderInputEditStatus } from './useRenderInputEditStatus';

export default useRenderInputEditStatus;
